module.exports = __webpack_public_path__ + "static/other_research_01-c00438953bfc081528a2d8e4602ceb0c.jpg";